import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-flush pt-3 mb-5 mb-lg-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Sipariş Ekle")
], -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-arrow-left" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "card-body pt-0" }
const _hoisted_8 = { class: "p-grid p-fluid" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Müşteri")
], -1)
const _hoisted_12 = { class: "col-md-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Artikel Numarası")
], -1)
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Sipariş Durumu")
], -1)
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Sezon")
], -1)
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Order")
], -1)
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "öko-Tex")
], -1)
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Departman")
], -1)
const _hoisted_26 = { class: "col-md-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Model Kodu")
], -1)
const _hoisted_28 = { class: "col-md-4" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-md-4" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Sip. Tarihi ")
], -1)
const _hoisted_34 = { class: "col-md-4" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Yük. Tarihi")
], -1)
const _hoisted_36 = { class: "col-md-4" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Varış Tarihi")
], -1)
const _hoisted_38 = { class: "col-md-4" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Üretici")
], -1)
const _hoisted_40 = { class: "col-md-4" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", {
  class: "d-flex align-items-center fs-6 fw-bold form-label mb-2",
  style: {"margin-top":"11px"}
}, null, -1)
const _hoisted_42 = { class: "card-footer d-flex justify-content-start py-6 px-9" }

import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Field } from "vee-validate";
import Modal from "@/components/Modal.vue";
import Form from "./components/Form.vue";
import { useToast } from "primevue/usetoast";
import Customer from "@/components/customers/CustomerSingleSelect.vue";
import Season from "@/components/seasons/Season.vue";
import Department from "@/components/departments/Department.vue";
import Supplier from "@/components/suppliers/SupplierSingleSelect.vue";
import NexeraFileUpload from "@/components/NexeraFileUpload.vue";
import Order from "@/types/Order";
import CustomerModel from "@/types/Customer";
import SupplierModel from "@/types/Supplier";
import DepartmentModel from "@/types/Department";
import SeasonModel from "@/types/Season";
import Status from "./components/Status.vue";
import { useRouter, useRoute } from "vue-router";
import Checkbox from "primevue/checkbox";

import moment from "moment";

export default /*#__PURE__*/_defineComponent({
  __name: 'Add',
  setup(__props) {

const router = useRouter();
// onMounted(() => {
//   setCurrentPageBreadcrumbs("", ["Sipariş Yönetimi", "Sipariş Ekle"]);
// });
const toast = useToast();
const store = useStore();
const isActive = ref(false);
const files: any = ref([]);
const date: any = ref();
const oekoTex: boolean = ref(false);
const estimatedDeliveryDate: any = ref();
const estimatedShippingDate: any = ref();
var body = document.body;

const toggleModal = () => {
  isActive.value = !isActive.value;
  if (isActive.value) {
    body.classList.add("p-overflow-hidden");
  } else {
    body.classList.remove("p-overflow-hidden");
  }
};
const goBack = () => {
  window.history.length > 1 ? router.go(-1) : router.push("/");
};
let customer: CustomerModel = {
  id: 0,
  name: "",
  code: "",
};
let department: DepartmentModel = {
  id: 0,
  name: "",
  code: "",
};
let season: SeasonModel = {
  id: 0,
  name: "",
  code: "",
};
let supplier: SupplierModel = {
  id: 0,
  name: "",
  code: "",
};
let order: Order = {
  articleNumber: "",
  date: "",
  explain: "",
  modelCode: "",
  estimatedDeliveryDate: "",
  estimatedShippingDate: "",
  customerId: 0,
  departmentId: 0,
  seasonId: 0,
  supplierId: 0,
  code: "",
  externalId: 0,
  id: 0,
  isActive: null,
  oekoTex: false,
};

const saveChanges = () => {
  store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
  let formData = new FormData();
  
  
  if(!date.value){
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
     error("Lütfen sipariş tarihini doldurunuz.");
     return;
  }
  if(!estimatedShippingDate.value){
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
     error("Lütfen yükleme tarihini doldurunuz.");
     return;
  }
  if(!estimatedDeliveryDate.value){
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
     error("Lütfen varış tarihini doldurunuz.");
     return;
  }
  if(!order.code){
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
     error("Lütfen order giriniz.");
     return;
  }

  order.date = moment(date.value).format().toString();
  order.estimatedDeliveryDate = moment(estimatedDeliveryDate.value).format().toString();
  order.estimatedShippingDate = moment(estimatedShippingDate.value).format().toString();
  order.oekoTex = oekoTex.value;
  for (var keys in files.value) {
    formData.append("files", files.value[keys]);
  }
  for (var key in order) {
    formData.append(key, order[key]);
  }

  store.dispatch(Actions.ADD_ORDER, formData).then((x) => {
    if (x.success) {
      router.push({
        name: "order-detail",
        params: { id: x.value.id, sizeSet: 1 },
      });
      store.dispatch(Actions.ORDER_LIST, 0).then((f) => {
        if (f.success) {
          success(x.message);
        } else {
          error(x.message);
        }
      });
    } else {
      error(x.message);
    }
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    toggleModal();
  });
};

const selectedCustomer = (args) => {
  order.customerId = args.value.value;
};
const selectedSeason = (args) => {
  order.seasonId = args.value.value;
};
const selectedDepartment = (args) => {
  order.departmentId = args.value.value;
};
const selectedSupplier = (args) => {
  order.supplierId = args.value.value;
};
const upload = (args) => {
  for (let i = 0; i < args.length; i++) {
    files.value.push(args[i]);
  }
  console.log(files.value);
};
const getFileKey = (args) => {
  console.log(args.value.value);
};
const selectedStatus = (args) => {
  order.isActive = args.value.value;
};
const success = (message) => {
  toast.add({
    severity: "success",
    summary: "İşlem Sonucu",
    detail: message,
    life: 3000,
  });
};

const error = (message) => {
  toast.add({
    severity: "error",
    summary: "İşlem Sonucu",
    detail: message,
    life: 3000,
  });
};
const getOrder = computed(() => order);

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (goBack())),
            class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
          }, _hoisted_6)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(Customer, { onChangeCustomer: selectedCustomer })
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: _unref(order).articleNumber,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(order).articleNumber) = $event)),
                class: "col-md-12"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(Status, {
                onChangeStatus: selectedStatus,
                data: { isActive: 1 }
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(Season, { onChangeSeason: selectedSeason })
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: _unref(order).code,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(order).code) = $event)),
                class: "col-md-12"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_unref(Checkbox), {
                id: "binary",
                modelValue: oekoTex.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((oekoTex).value = $event)),
                binary: true
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createVNode(Department, { onChangeDepartment: selectedDepartment })
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: _unref(order).modelCode,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(order).modelCode) = $event)),
                class: "col-md-12"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_Textarea, {
                modelValue: _unref(order).explain,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(order).explain) = $event)),
                rows: "3",
                cols: "100",
                placeholder: "Açıklama"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((date).value = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, date.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((estimatedShippingDate).value = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, estimatedShippingDate.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((estimatedDeliveryDate).value = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, estimatedDeliveryDate.value]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createVNode(Supplier, { onChangeSupplier: selectedSupplier })
            ]),
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _createVNode(NexeraFileUpload, {
                onData: getFileKey,
                onUpload: upload
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("button", {
          type: "button",
          id: "kt_account_profile_details_submit",
          ref: "submitButton",
          class: "btn btn-primary",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (saveChanges()))
        }, " Kaydet ", 512)
      ])
    ])
  ], 64))
}
}

})